import React, { FunctionComponent, ReactElement } from 'react'
import ErrorWarningSmall from './Small'
import ErrorWarningBig from './Big'

export type ErrorWarningProps = {
    size: 'small' | 'big'
    infoText: string
    buttonText: string
    onPress: () => void
    marginTextTop?: 'small' | 'big'
    marginTextBottom?: 'small' | 'big'
}

const errorMargin = {
    small: 5,
    big: 7,
}

const ErrorWarning: FunctionComponent<ErrorWarningProps> = (data): ReactElement => {
    const { size, marginTextTop, marginTextBottom, infoText, buttonText, onPress } = data
    const marginTop = marginTextTop ? errorMargin[marginTextTop] : 5
    const marginBottom = marginTextBottom ? errorMargin[marginTextBottom] : 5
    return size === 'small' ? (
        <ErrorWarningSmall
            marginBottom={marginBottom}
            marginTop={marginTop}
            infoText={infoText}
            buttonText={buttonText}
            onPress={onPress}
        />
    ) : (
        <ErrorWarningBig
            marginBottom={marginBottom}
            marginTop={marginTop}
            infoText={infoText}
            buttonText={buttonText}
            onPress={onPress}
        />
    )
}

export default ErrorWarning
